// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nbeE","comment":"styles_comment__-5fEK"};